<template>
  <v-dialog v-model="dialog" width="1500px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t('StockOrderOUT.PickingOut.confirm') }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>

      <v-row align="center" class="ml-6 mr-6">
        <v-col cols="6">
          {{ $t("StockOrderOUT.PickingOut.TipsMsg") }}
        </v-col>
      </v-row>

      <v-data-table
              :headers="headers"
              :items="details"
              :loading="loading"
              multi-sort
              class="elevation-0 px-6"
              fixed-header
              height="600px"
              :footer-props="$t('$config.footer-props')"
      >
        <template v-slot:item.confirm_num="{ item }">
              <span>
                {{ item.confirm_num }}{{ item.unit }}
              </span>
        </template>
        <template v-slot:item.sorting_num="{ item }">
              <span>
                {{ item.sorting_num }}{{ item.unit }}
              </span>
        </template>
      </v-data-table>

      <v-card-actions>
        <v-btn
          color="primary"
          outlined
          @click="$emit('back', null)"
          class="elevation-1"
        >
          {{ $t("StockOrderOUT.PickingOut.backBtn") }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="dialog = false"
          class="elevation-1"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn
          color="primary"
          @click.stop="doSubmit(1)"
        >
          {{ $t("StockOrderOUT.PickingOut.confirmBtn") }}
        </v-btn>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    class="ml-2"
                    @click.stop="doSubmit(2)"
            >
              {{ $t("StockOrderOUT.PickingOut.confirm") }}
            </v-btn>
          </template>
          <span>{{ $t("StockOrderOUT.PickingOut.confirmMsg") }}</span>
        </v-tooltip>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import StockOuts from "@/api/stock_outs";


export default {
  name: "DialogConfirm",

  components: {},

  props: {
    value: Boolean,
    options: Object,
    confirmData: Object,
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("StockOrderOUT.PickingOut.Fields.shop_name"),
          align: "start",
          sortable: false,
          value: "shop_name",
        },
        {
          text: i18n.t("StockOrderOUT.PickingOut.Fields.stock_order_code"),
          align: "start",
          sortable: false,
          value: "stock_order_code",
        },
        {
          text: i18n.t("StockOrderOUT.PickingOut.Fields.materials_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("StockOrderOUT.PickingOut.Fields.confirm_num"),
          align: "start",
          sortable: false,
          value: "confirm_num",
        },
        {
          text: i18n.t("StockOrderOUT.PickingOut.Fields.sorting_num"),
          align: "start",
          sortable: false,
          value: "sorting_num",
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    details: {},
    confirmOptions: {},
    paging: {},
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.details = this.confirmData.details;
        this.confirmOptions = this.confirmData.options;
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
  },

  methods: {
    doSubmit(type) {
      this.confirmOptions.prat_sorting_out_mode = type
      StockOuts.batchSortingOut(this.confirmOptions).then(
              function (response) {
                if (response.data.status.isOK()) {
                  if (type == 1) {
                    this.$snackbar.success(i18n.t("StockOrderOUT.Messages.pickingOutConfirmSuccess"));
                  }else if (type == 2) {
                    this.$snackbar.success(i18n.t("StockOrderOUT.Messages.pickingOutSuccess"));
                  }
                  this.$emit("confirm", this.dialog);
                }
              }.bind(this))
    },
  },
};
</script>
